module.exports = __webpack_public_path__ + "img/zhinengzhizao_dugeng_suoluetu.d0290437.png";